module.exports = __webpack_public_path__ + "img/about.f1fa499f.png";